export function getFileName(url) {
    if (url) {
        const filename = url.substring(url.lastIndexOf("/") + 1).replace(/\?.*$/, "");
        return filename;
    }
    return "";
}
//# sourceMappingURL=urlUtils.js.map